import { useEffect } from 'react'
import { Platform } from 'react-native'

import type { User as BackendUser } from '../dal/user-dal'
import type { User as AuthUser } from '../hooks/useAuth0Adapter'
import type { BackendUserStatus } from './app-session-state'
import { identifyUser } from '../services/analytics'
import {
  addBreadcrumb,
  clearUserContext,
  setUserContext,
} from '../utils/sentry'

export function useAppSessionAuthEffects({
  appVersion,
  backendUser,
  backendUserStatus,
  isAuthenticated,
  user,
}: {
  appVersion: string | undefined
  backendUser: BackendUser | null | undefined
  backendUserStatus: BackendUserStatus
  isAuthenticated: boolean
  user: AuthUser | null | undefined
}) {
  useEffect(() => {
    if (isAuthenticated && user?.sub) {
      setUserContext({ id: user.sub, email: user.email })
      if (backendUserStatus === 'ready' && backendUser?.mixpanelId) {
        void identifyUser(backendUser.mixpanelId, user.name, user.email, {
          platform: Platform.OS,
          appVersion,
        })
      } else if (backendUserStatus === 'ready') {
        addBreadcrumb(
          'auth',
          'mixpanel_id_missing',
          {
            authUserId: user.sub,
            revenueCatId: backendUser?.revenueCatId ?? null,
          },
          'warning',
        )
        console.warn(
          'Authenticated user is missing backend Mixpanel ID; Mixpanel identify skipped.',
        )
      }
      addBreadcrumb('auth', 'user_authenticated', { userId: user.sub })
    } else if (!isAuthenticated) {
      clearUserContext()
    }
  }, [
    appVersion,
    backendUser?.mixpanelId,
    backendUser?.revenueCatId,
    backendUserStatus,
    isAuthenticated,
    user?.email,
    user?.name,
    user?.sub,
  ])
}
